"use client";

import ImageWithLightbox from "@/components/shared/media/ImageWithLightbox";

export interface InlineImageViewProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  position?: "left" | "right";
}

export default function InlineImageView({
  src,
  alt,
  width,
  height,
  position = "left",
}: InlineImageViewProps) {
  return (
    <ImageWithLightbox
      url={src}
      alt={alt}
      width={width}
      height={height}
      fullSizeWidth={width}
      fullSizeHeight={height}
      sizes="250px"
      wrapperClassName={`inline-block w-2/5 xl:max-w-[250px] ${
        position === "left" ? "float-left mr-6" : "float-right ml-6"
      }`}
      imageClassName="my-0! h-auto w-full cursor-pointer"
    />
  );
}
